import { MarketType } from 'src/solace/constants/marketType.enum';

export class OperationError {
  title?: string;
  message: string;
  eventId?: any;
  errorCode?: number;
  isBusinessError?: boolean;
  isBuyOperation?: boolean;
  error: any;

  constructor(
    error: any,
    isBuy?: boolean,
    instrumentType: MarketType = MarketType.BMV,
  ) {
    this.error = this.parseJSON(error);
    this.message =
      error.ErrorMessage ??
      error.message ??
      'Se ha detectado un error. Por favor, intente de nuevo.';
    this.eventId = error.EventId ?? error.event_id;
    this.isBusinessError = error.IsBussinessError;
    this.title = error.title ?? '';
    this.isBuyOperation = isBuy;
    this.errorCode = error.ErrorCode;

    /**
     * Spread error is identified with 14 error code
     */
    if (this.errorCode === 14) {
      this.createSpreadError(instrumentType);
    }
  }

  toJSON() {
    return {
      error: this.error,
      title: this.title,
      message: this.message,
      eventId: this.eventId,
      errorCode: this.errorCode,
      isBuyOperation: this.isBuyOperation,
      isBusinessError: this.isBusinessError,
    };
  }

  parseJSON(value: any) {
    try {
      return JSON.stringify(value);
    } catch (e) {
      return '';
    }
  }

  private createSpreadError(instrumentType: MarketType) {
    const isSic = instrumentType === MarketType.SIC;
    const tighterLimit = isSic ? 5 : 3;
    const widerLimit = isSic ? 10 : 6;
    const upperLimit = this.isBuyOperation ? tighterLimit : widerLimit;
    const lowerLimit = this.isBuyOperation ? widerLimit : tighterLimit;
    const operation = this.isBuyOperation ? 'comprar' : 'vender';

    this.title = 'La orden supera el límite del Spread permitido';
    this.message = `<span>El precio objetivo debe estar entre el ${lowerLimit}% por debajo y el ${upperLimit}% por encima del precio de mercado del instrumento.</span>
    <br><br><span>Es decir, si el precio de mercado es 100, lo más caro que puedes ${operation} es ${
      100 + upperLimit
    } y lo más barato ${100 - lowerLimit}.</span>`;
  }
}
